import { Compass } from 'lucide-react';
import { Link } from 'react-router-dom';
import { ModuleHero } from '../components/ModuleHero';

export function NotFoundPage() {
  return (
    <>
      <ModuleHero
        eyebrow="404"
        title="That route hasn't been built yet."
        description="The foundation sprint covers every primary space. If you reached this, the URL is off — head back to your dashboard."
        icon={Compass}
      />
      <div className="row">
        <Link to="/" className="btn btn--primary">Take me home</Link>
      </div>
    </>
  );
}
